import { api } from './api';

/**
 * Fetches management dashboard data.
 *
 * The backend aggregates multiple widgets (brands, personas, drafts, topPosts,
 * followers, etc.). The Dashboard UI can pick the sections it needs.
 */
export const fetchManagementDashboard = async (applanguage: string) => {
  const response = await api.get('/management/dashboard', {
    params: { applanguage }
  });
  return response.data;
};


